<template>
    <div v-if="isMounted">
        <vs-tabs v-model="activeTab" color="warning" alignment="fixed" class="tab-action-btn-fill-container">
            <vs-tab v-for="(project, i) in allProjectsNegotiations" :key="i" :label="project.project_id+'-'+project.alias">
                <div class="vx-row">
                    <div class="vx-col w-full md:w-1/4">
                        <div class="mt-5">
                            <h6 class="bold">Negociación:</h6>
                            <vs-select class="w-full"
                                v-model="project.negotiation_type"
                                :disabled="project.negotiated || loading"
                                placeholder="Seleccione una opción" >
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in negotiationOptions" class="w-full" />
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/4" v-if="project.negotiation_type == 'meses_de_gracia' || project.negotiation_type == 'solo_intereses'">
                        <div class="mt-5">
                            <h6 class="bold">Meses:</h6>
                            <vs-select class="w-full"
                                v-model="project.months"
                                :disabled="project.negotiated || loading"
                                placeholder="Seleccione una opción" >
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in monthsOptions" class="w-full" />
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/4" v-if="!project.negotiated">
                        <div class="mt-5">
                            <h6 class="bold">Archivo de solicitud:</h6>
                            <input type="file" class="form-control" :id="'request_file_'+project.id" :name="'request_file_'+project.id" :ref="'request_file_'+project.id" accept="image/png, image/jpeg, application/pdf" :disabled="project.negotiated || loading">
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/4">
                        <div class="mt-base">
                            <vs-button class="mt-2" v-if="!project.negotiated" size="small" color="success" @click="confirmNegotiation(project)">Guardar</vs-button>
                            <vs-button class="mt-2" v-else-if="project.negotiation_type == 'sin_recargos'" size="small" color="danger" @click="confirmCancelNegotiation(project)">Cancelar</vs-button>
                        </div>
                    </div>
                </div>      
            </vs-tab>
        </vs-tabs>
        <!-- COMFIRMACION DE NEGOCIACION 2FA -->
        <vs-prompt title="Confirmar operación" @cancel="twoFactorCode = ''" @accept="makeNegotiation" color="success"
            accept-text="Confirmar" cancel-text="Cancelar" :is-valid="validTwoFactorCode"
            :active.sync="negotiationActivePrompt">
            <div class="con-exemple-prompt">
                <span>Negociación PID <strong>({{ currentProject.project_id }})</strong><br>Confirma con tu
                segundo factor de autenticación</span>
                <vs-input placeholder="Código" vs-placeholder="Code" v-model="twoFactorCode" class="mt-3 w-full" />
            </div>
        </vs-prompt>

        <!-- COMFIRMACION DE CANCELACION DE NEGOCIACION 2FA -->
        <vs-prompt title="Confirmar operación" @cancel="twoFactorCode = ''" @accept="cancelNegotiation" color="success"
            accept-text="Confirmar" cancel-text="Cancelar" :is-valid="validTwoFactorCode"
            :active.sync="cancelNegotiationActivePrompt">
            <div class="con-exemple-prompt">
                <span>Cancelar negociación PID <strong>({{ currentProject.project_id }})</strong><br>Confirma con tu
                segundo factor de autenticación</span>
                <vs-input placeholder="Código" vs-placeholder="Code" v-model="twoFactorCode" class="mt-3 w-full" />
            </div>
        </vs-prompt>
    </div>
</template>

<script>
    export default {
        name: "Negotiations",
        props: ['project_id'],
        data(){
            return {
                isMounted: false,
                allProjectsNegotiations: [],
                currentProject: {
                    alias:null,
                    months: null,
                    negotiated: false,
                    negotiation_type: null,
                    project_id: null
                },
                activeTab: 0,
                negotiationActivePrompt: false,
                cancelNegotiationActivePrompt: false,
                negotiationOptions: [
                    { text: "Sin recargos", value: 'sin_recargos'},
                    { text: "Meses de gracia", value: 'meses_de_gracia'},
                    { text: "Solo intereses", value: 'solo_intereses'}
                ],
                monthsOptions: [
                    { text: "1", value: '1'},
                    { text: "2", value: '2'},
                    { text: "3", value: '3'},
                    { text: "4", value: '4'},
                    { text: "5", value: '5'},
                    { text: "6", value: '6'}
                ],
                negotiation: '',
                months: undefined,
                negotiated: false,
                loading: false,
                twoFactorCode: '',
            }
        },
        computed: {
            validTwoFactorCode() {
                return this.twoFactorCode !== "";
            },
        },
        async mounted(){
            await this.getNegotiation();
        },
        methods:{
            async getNegotiation(){
                this.isMounted=false;
                this.showLoading(true);
                await axios.get('/api/cobranza/negociaciones/' + this.project_id).then(response => {
                    this.allProjectsNegotiations = response.data.allProjectsNegotiations;
                }).catch();
                this.isMounted=true;
                this.showLoading(false);
            },
            confirmNegotiation(project){
                if (!project.negotiation_type) {
                    this.errorNotif("Aviso", "Debes seleccionar un tipo de negociación", 4000);
                    return;
                } else {
                    if (project.negotiation_type != 'sin_recargos' && project.months <= 0) {
                        this.errorNotif("Aviso", "Debes seleccionar la cantidad de meses", 4000);
                        return;
                    }
                }
                let file = document.getElementById('request_file_'+project.id);
                if(file.files.length == 0 && project.negotiation != 'sin_recargos'){
                    this.errorNotif("Aviso", "Debes agregar el archivo de la negociación", 4000);
                    return;
                }
                this.currentProject = project;
                this.negotiationActivePrompt = true;
            },
            async makeNegotiation(){
                let project = this.currentProject;
                let file = document.getElementById('request_file_'+project.id);
                this.showLoading(true);
                this.loading = true;
                await axios.post('/api/cobranza/negociaciones', {
                    project_id: project.project_id,
                    type: project.negotiation_type,
                    months: project.months,
                    code: this.twoFactorCode,
                    file: file.files.length > 0? file.files[0]:null
                }).then(response => {
                    this.showLoading(false);
                    this.loading = false
                    this.$emit('updated', 1)
                    this.successNotif("Aviso", 'Cambios guardados de manera exitosa.');
                }).catch(error => {
                    this.showLoading(false);
                    if (error?.response?.data?.message != undefined) {
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    } else {
                        this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                    }
                    this.loading = false
                })
                this.twoFactorCode = '';
            },
            confirmCancelNegotiation(project){
                this.currentProject = project;
                this.cancelNegotiationActivePrompt = true;
            },
            async cancelNegotiation(){
                let project = this.currentProject;
                this.showLoading(true);
                this.loading = true;
                await axios.post('/api/cobranza/negociaciones/cancelar', {
                    project_id: project.project_id,
                    code: this.twoFactorCode,
                }).then(response => {
                    this.showLoading(false);
                    this.loading = false
                    this.$emit('updated', 1)
                    this.successNotif("Aviso", 'Cambios guardados de manera exitosa.');
                }).catch(error => {
                    this.showLoading(false);
                    if (error?.response?.data?.message != undefined) {
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    } else {
                        this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                    }
                    this.loading = false
                })
                this.twoFactorCode = '';
            }
        }
    }
</script>
